export const LOGO_URL = "/img/cv-folks-logo.webp";

export const PACKAGES = [
  {
    id: "standard-cv",
    name: "Standard CV",
    tier: "standard",
    price: 50,
    tag: "Best for fast results",
    description:
      "A persuasive, ATS-optimised CV crafted by a UK-based expert writer.",
    features: [
      "Advanced formatting & polished design",
      "ATS-friendly layout that passes scanners",
      "Industry keyword optimisation",
      "Persuasive, recruiter-tested language",
      "Tailored to your target role",
      "6 months free revisions",
      "60-Day Interview Guarantee",
    ],
    popular: false,
  },
  {
    id: "standard-package",
    name: "Standard Package",
    subtitle: "CV + Cover Letter + LinkedIn",
    tier: "standard",
    price: 95,
    tag: "Most Popular — Best Value",
    description:
      "Our complete career package — interview-winning CV, tailored cover letter and full LinkedIn makeover.",
    features: [
      "Everything in Standard CV",
      "Tailored, persuasive Cover Letter",
      "LinkedIn Profile Makeover (headline, summary, experience)",
      "Recruiter visibility boost with keywords",
      "Consistent personal brand across documents",
      "6 months free revisions",
      "60-Day Interview Guarantee",
    ],
    popular: true,
  },
  {
    id: "premium-cv",
    name: "Premium CV",
    tier: "premium",
    price: 125,
    tag: "For senior & executive roles",
    description:
      "A premium CV with senior-level positioning, personal branding refinement and a 1-on-1 career consultation call.",
    features: [
      "Everything in Standard CV",
      "1-on-1 career consultation call (30 mins)",
      "Senior-level positioning & narrative",
      "Personal branding refinement",
      "Tailored to executive / senior recruiters",
      "12 months free revisions",
      "60-Day Interview Guarantee",
    ],
    popular: false,
  },
  {
    id: "premium-package",
    name: "Premium Package",
    subtitle: "CV + Cover Letter + LinkedIn + Call",
    tier: "premium",
    price: 155,
    tag: "Flagship — Most Complete",
    description:
      "The complete career upgrade — Premium CV, tailored Cover Letter, LinkedIn makeover and a 45-min strategy call.",
    features: [
      "Everything in Premium CV",
      "Tailored, executive-grade Cover Letter",
      "LinkedIn Profile Makeover",
      "Extended 1-on-1 strategy call (45 mins)",
      "Priority 24h turnaround",
      "12 months free revisions",
      "60-Day Interview Guarantee",
    ],
    popular: true,
  },
];

export const VIDEO_TESTIMONIALS = [
  {
    id: "v1",
    name: "Happy Client",
    role: "Landed an interview within 3 weeks",
    poster: "/posters/v1.jpg",
    src: "https://customer-assets.emergentagent.com/job_08cffbcb-4bd1-43ee-adee-3b5118ee9715/artifacts/oi8yde5j_Video%20%282%29%20%283%29.mov",
  },
  {
    id: "v2",
    name: "Verified Customer",
    role: "Got hired in finance, London",
    poster: "/posters/v2.jpg",
    src: "https://customer-assets.emergentagent.com/job_08cffbcb-4bd1-43ee-adee-3b5118ee9715/artifacts/gfkv1p2u_VID-20220709-WA0000%20%283%29.mp4",
  },
  {
    id: "v3",
    name: "CV Folks Client",
    role: "Career change success",
    poster: "/posters/v3.jpg",
    src: "https://customer-assets.emergentagent.com/job_08cffbcb-4bd1-43ee-adee-3b5118ee9715/artifacts/xa302d5t_IMG_0731%20%282%29.MOV",
  },
  {
    id: "v4",
    name: "Senior Professional",
    role: "Promoted within 6 weeks",
    poster: "/posters/v4.jpg",
    src: "https://customer-assets.emergentagent.com/job_08cffbcb-4bd1-43ee-adee-3b5118ee9715/artifacts/t7ak79kq_20220816_234209%20%281%29.mp4",
  },
  {
    id: "v5",
    name: "Recent Graduate",
    role: "First role after university",
    poster: "/posters/v5.jpg",
    src: "https://customer-assets.emergentagent.com/job_08cffbcb-4bd1-43ee-adee-3b5118ee9715/artifacts/8f1qpmor_20220208_103328%20%281%29.mp4",
  },
];

export const GOOGLE_REVIEWS = {
  rating: 4.8,
  count: 47,
  url: "https://share.google/WwAvv4ifxEJ08OSWv",
  reviews: [
    {
      name: "Daniel",
      initial: "D",
      rating: 5,
      timeAgo: "a few weeks ago",
      text: "Great communication and really good work ethic — best money I've spent in a while.",
      color: "#0F9D58",
    },
    {
      name: "Charlie Sread",
      initial: "C",
      rating: 5,
      timeAgo: "2 months ago",
      text: "The turnaround was a matter of days and the quality of the work is superb.",
      color: "#DB4437",
    },
    {
      name: "Solomon Beshah",
      initial: "S",
      rating: 5,
      timeAgo: "3 months ago",
      text: "They have helped me to polish and give a bit of sparkle to my CV and cover letter.",
      color: "#4285F4",
    },
    {
      name: "Aisha K.",
      initial: "A",
      rating: 5,
      timeAgo: "5 months ago",
      text: "Recruiters started reaching out within a week. The LinkedIn makeover was a game-changer.",
      color: "#F4B400",
    },
    {
      name: "James M.",
      initial: "J",
      rating: 5,
      timeAgo: "6 months ago",
      text: "Worth every penny. Got two interviews within the 60-day guarantee window.",
      color: "#9C27B0",
    },
    {
      name: "Priya R.",
      initial: "P",
      rating: 5,
      timeAgo: "7 months ago",
      text: "Professional, fast, and the CV looks beautiful. The ATS-optimisation actually works.",
      color: "#00ACC1",
    },
    {
      name: "Marcus T.",
      initial: "M",
      rating: 5,
      timeAgo: "1 month ago",
      text: "Honestly the best decision I made in my job hunt. Three interviews in the first fortnight.",
      color: "#FF6D00",
    },
    {
      name: "Hannah L.",
      initial: "H",
      rating: 5,
      timeAgo: "2 weeks ago",
      text: "Friendly, fast, and genuinely cared about my career goals. My new CV reads like a story, not a checklist.",
      color: "#3F51B5",
    },
    {
      name: "Olu A.",
      initial: "O",
      rating: 5,
      timeAgo: "4 months ago",
      text: "Pivoted from teaching into ed-tech — they translated my classroom experience perfectly.",
      color: "#E91E63",
    },
    {
      name: "Rohan S.",
      initial: "R",
      rating: 5,
      timeAgo: "8 months ago",
      text: "I'd been ghosted for months. After the rewrite, I had four recruiter calls in two weeks.",
      color: "#009688",
    },
    {
      name: "Emma W.",
      initial: "E",
      rating: 5,
      timeAgo: "3 weeks ago",
      text: "Communication was brilliant and the final CV looks worth every penny. Thank you!",
      color: "#7B1FA2",
    },
    {
      name: "Liam P.",
      initial: "L",
      rating: 5,
      timeAgo: "5 months ago",
      text: "Smashed my interview at a top consultancy thanks to the new CV and LinkedIn revamp.",
      color: "#0288D1",
    },
  ],
};

export const CONTACT = {
  email: "cvfolksbritain@gmail.com",
  whatsapp: "+44 7448457089",
  whatsappRaw: "447448457089",
  address: "354 Gray's Inn Rd, London WC1X 8BP, United Kingdom",
};
